import React, { FC, memo, useEffect, useState } from 'react'

import { BgImagePositions } from '@/constants/common'
import { BackgroundImage } from '@/containers/styles'
const errorSrc =
  'https://sportworld-public-assets.cdn.dev.b1smarttv.com/temp/high-resolution-wallpapers-25.jpg'

export const PageBackgroundRaw: FC<{
  src?: string
  backgroundImagePosition?: BgImagePositions
}> = ({ src, backgroundImagePosition }) => {
  const [backgroundSrc, setBackgroundSrc] = useState('')

  useEffect(() => {
    src && setBackgroundSrc(src)
  }, [src])

  const handleImageLoadResult = (currentTarget: HTMLImageElement) => {
    currentTarget.className = 'isVisible'
  }
  const isFixedPosition =
    backgroundImagePosition?.toLowerCase() === BgImagePositions.FIXED

  if (!backgroundSrc) {
    return null
  }

  return (
    <BackgroundImage $isFixedPosition={isFixedPosition}>
      <img
        src={backgroundSrc}
        onLoad={({ currentTarget }) => {
          handleImageLoadResult(currentTarget)
        }}
        onError={() => {
          setBackgroundSrc(errorSrc)
        }}
        alt=""
      />
    </BackgroundImage>
  )
}

export const PageBackground = memo(PageBackgroundRaw)
